import { Subject } from 'rxjs';

const subject = new Subject();

export const messageService = {
  sendMessage: (data: any) => subject.next({ data: data }),
  clearMessages: () => subject.next(null),      // subject.next() cannot be empty.
  getMessage: () => subject.asObservable(),
};
